<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <Alert banner closable>搜索支持全局搜索，多条件搜索时请使用“|”作为条件分隔符</Alert>
          <div class="search-con search-con-top">
            <Input class="search-input" v-model="searchVal" style="padding:5px;" placeholder="输入关键字全局搜索" @on-enter="searchinput"/>
            <slot name="new_btn">
              <Button type="primary" @click="editModal('', 'post', '添加市场')" class="search-btn">添加市场</Button>
            </slot>
            <Button type="error" class="search-btn" @click="handlerDelete">批量删除</Button>

          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>
          <Table v-loading.fullscreen.lock="fullscreenLoading" height="670" size="small" ref="selection" border :columns="columns" :data="tableData"
                 @on-selection-change="handleSelectChange"></Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>
          <Modal v-model="modalMap.modalVisible" :title="modalMap.modalTitle" :loading=true :footer-hide=true
                 :mask-closable=false>
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="85">

              <Alert >TIPS：市场名称必输！</Alert>
                <FormItem
                  label="市场名称"
                  prop="Mname"
                >
                  <Input
                    v-model="formValidate.Mname"
                    :maxlength="45"
                    placeholder="请输入市场名称"
                  ></Input>

                </FormItem>
              <FormItem label="地址" prop="Address">
                <Input
                  v-model="formValidate.Address"
                  :maxlength="45"
                  placeholder="请输入地址"
                ></Input>
              </FormItem>

              <FormItem label="联系人" prop="Linkman">

                <Input
                       v-model="formValidate.Linkman"
                       :maxlength="45"
                       placeholder="请输入联系人"
                ></Input>

              </FormItem>
              <FormItem label="联系方式" prop="Phone">

                <Input
                       v-model="formValidate.Phone"
                       :maxlength="45"
                       placeholder="请输入联系方式"
                ></Input>
              </FormItem>
              <FormItem label="市场关联" prop="Oldid">
                <Select  v-model="formValidate.Oldid" placeholder="请选择人才网市场" filterable>
                  <Option v-for="item in OldMartetList" :value="item.MARKETID" :key="item.MARKETID">{{item.MNAME}}</Option>
                </Select>
              </FormItem>

              <FormItem>

                <Button
                        type="primary"
                        @click="handleSubmit('formValidate')"
                >提交
                </Button>
                <Button
                  @click="handleReset('formValidate')"
                  style="margin-left: 8px"
                >重置
                </Button>
              </FormItem>

            </Form>
          </Modal>
        </Card>
      </i-col>
    </Row>

  </div>
</template>

<script>

  import {
    getMarketlist,
    operationMarket,
    getoldmartetList
  } from '@/api/scinfo/scinfo.js'

  import { getsysparameterList } from '@/api/system/sys_parameter'

  // import {Notification} from 'element-ui';

  export default {

    data () {
      return {
        spinShow: false,
        fullscreenLoading: false,
        exportLoading: false,
        index: 1,
        loading: false,
        logModal: false,
        OldMartetList: [],
        formValidate: {
          Id: 0,
          Mname: '',
          Address: '',
          Linkman: '',
          Phone: '',
          Addtime: '',
          Creater: '',
          Createrid: '',
          Flag: '',
          Remark: '',
          Updatetime: '',
          Oldid: ''
        },
        searchVal: '',
        single: false,
        loadingStatus: false,
        tableData: [],
        modalMap: {
          modalVisible: false,
          modalTitle: '新建'
        },
        tableSelectIdList: [],
        editModalData: '',
        pageNum: 1, // 当前页码
        pageTotal: 0, // 数据总数
        pageSize: 15, // 每页条数

        ruleValidate: {
          // admin_user: [{ required: true, message: "请选择管理用户", trigger: "change"}],
          Mname: [
            {
              required: true,
              message: '市场名称不能为空',
              trigger: 'blur'
            }
          ],
          Address: [
            {
              required: true,
              message: '地址不能为空',
              trigger: 'blur'
            }
          ],
          Linkman: [
            {
              required: true,
              message: '联系人不能为空',
              trigger: 'blur'
            }
          ],
Phone: [
            {
              required: true,
              message: '电话不能为空',
              trigger: 'blur'
            }
          ]

        },
        columns: [
          {
            type: 'selection',
            key: 'id',
            width: 60,

            align: 'center'
          },
          {
            title: '市场名称',
            key: 'Mname',
            width: 270,
            align: 'center',
            sortable: true
          },
          {
            title: '地址',
            key: 'Address',
            align: 'center',
            sortable: true
          },
          {
            title: '联系人',
            key: 'Linkman',
            width: 120,
            align: 'center',
            sortable: true
          },
          {
            title: '联系电话',
            key: 'Phone',
            width: 130,
            align: 'center',
            sortable: true
          },

          {
            title: '操作',
            key: 'handle',
            width: 130,
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h(
                  'Button',
                  {
                    props: {
                      type: 'primary',
                      size: 'small'
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.editModal(params.row, 'put', '修改')
                      }
                    }
                  },
                  '编辑'
                ),
                h(
                  'Button',
                  {
                    props: {
                      type: 'error',
                      size: 'small'
                    },
                    on: {
                      click: () => {
                        this.delData(params)
                      }
                    }
                  },
                  '删除'
                )
              ])
            }
          }
        ]
      }
    },
    methods: {

      // closeModal() {
      //   this.over()
      // },
      // 获取TagTree
      getOldMartetList () {
        getoldmartetList('').then(res => {
          if (res.data.code === 0) {
            this.OldMartetList = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      },

      getMarketlist (key, value) {
        // console.log(this.columns[7].filters)
        this.spinShow = true
        getMarketlist(this.pageNum, this.pageSize, key, value).then(res => {
          if (res.data.code === 0) {
            // console.log(this.columns[6].filters)
            this.pageTotal = res.data.count
            this.tableData = res.data.data
            // this.columns[8].filters=res.data.police_station_CN;
            // this.columns[9].filters=res.data.idc_CN;
            // this.columns[10].filters=res.data.tv_station_CN;
            // console.log(this.columns[7].filters)
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
          this.spinShow = false
        })
      },

      handleRemove (index) {
        this.formValidate.args_items[index].status = 0
      },

      // table 选中的ID
      handleSelectChange (val) {
        let SelectIdList = []
        val.forEach(item => {
          SelectIdList.push(item.Id)
        })

        this.tableSelectIdList = SelectIdList
      },

      closeModal () {
        this.dialog.show = false
      },

      editModal (paramsRow, meth, mtitle) {
        this.modalMap.modalVisible = true
        this.modalMap.modalTitle = mtitle
        this.editModalData = meth

        if (paramsRow && paramsRow.Id) {
          // put

          this.formValidate = {
            Id: paramsRow.Id,
            Mname: paramsRow.Mname,
            Address: paramsRow.Address,
            Linkman: paramsRow.Linkman,
            Phone: paramsRow.Phone,
            Oldid: paramsRow.Oldid

          }
        } else {
            this.formValidate = {
              Id: '',
              Mname: '',
              Address: '',
              Linkman: '',
              Phone: '',
              Oldid: ''
            }
          }
      },
      handleSubmit (value) {
        this.$refs[value].validate((valid) => {
          if (valid) {
            setTimeout(() => {
              operationMarket(this.formValidate, this.editModalData).then(res => {
                if (res.data.code === 0) {
                  this.$Message.success(`${res.data.msg}`)

                    if (this.searchVal) {
                      this.getMarketlist(this.searchVal)
                    } else {
                      this.getMarketlist()
                    }
                  this.modalMap.modalVisible = false
                } else {
                  this.$Message.error(`${res.data.msg}`)
                }
              })
            }, 1000)
            // this.$Message.success('Success!');
          } else {
            this.$Message.error('缺少必要参数')
          }
        })
      },

      handleReset (name) {
        this.$refs[name].resetFields()
      },

      handlerDelete () {
        // console.log(this.tableSelectIdList.length)
        if (this.tableSelectIdList.length > 0) {
          if (confirm(`确定要批量删除选中设备 `)) {
            operationMarket({ 'id_list': this.tableSelectIdList }, 'delete').then(
              res => {
                if (res.data.code === 0) {
                  this.$Message.success(`${res.data.msg}`)
                  this.getMarketlist(this.searchVal)
                } else {
                  this.$Message.error(`${res.data.msg}`)
                }
              })
          }
        } else {
          this.$Message.info(`你总要选中点什么吧`)
        }
      },
      // 删除
      delData (params) {
        if (confirm(`确定要删除 ${params.row.Mname}`)) {
          // console.log(params.row.id)
          operationMarket(
            {
              'market_id': params.row.Id
            },
            'delete'
          ).then(res => {
            if (res.data.code === 0) {
              this.$Message.success(`${res.data.msg}`)
              this.tableData.splice(params.index, 1)
            } else {
              this.$Message.error(`${res.data.msg}`)
            }
          })
        }
      },

      handleSearch () {
        this.getServerList(this.searchVal)
      },
      // 点击节点
      // 翻页
      changePage (value) {
        this.pageNum = value
        if (this.searchVal) {
          this.getMarketlist(this.searchVal)
        } else {
          this.getMarketlist()
        }
      },
      // 切换分页
      handlePageSize (value) {
        this.pageSize = value
        this.pageNum = 1
        if (this.searchVal) {
          this.getMarketlist(this.searchVal)
        } else {
          this.getMarketlist()
        }
      },
      searchinput () {
        if (this.searchVal) {
          this.getMarketlist(this.searchVal)
        } else {
            this.getMarketlist()
        }
      }
    },

    watch: {
      searchVal (val) {
        this.searchVal = val
        // this.getServerList(this.searchVal)
      }
    },
    mounted () {
      this.getMarketlist()
      this.getOldMartetList()
    }
  }

</script>

<style lang="less" scoped>
  .search-con {
    padding: 10px 0;

    .search {
      &-col {
        display: inline-block;
        width: 200px;
      }

      &-input {
        display: inline-block;
        width: 200px;
        margin-left: 2px;
      }

      &-btn {
        margin-left: 2px;
      }
    }
  }
</style>
